import { slice } from './slice'

const initiativesActions = {
  ...slice.actions,
}

export default initiativesActions
